import React from 'react';
import { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import Navbar from '../navbar/Navbar';
import Sidebar from '../sidebar/Sidebar';
import ProfilePage from './ProfilePage';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();

const Profile = ({ loggedIn, handleLogout }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userData, setUserData] = useState([]);

  // API details
  const username = JSON.parse(localStorage.getItem('uname'));
  const URL = `https://stucharge.bakersbrisk.com/api/getapp?username=${username}`;
  const AuthStr = process.env.REACT_APP_AUTH_STR;

  useEffect(() => {
    axios
      .get(URL, { headers: { Authorization: AuthStr } })
      .then((response) => {
        // If request is good...
        if (response) {
          setUserData(response.data.user_details);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong, please refresh');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!loggedIn) {
    return <Redirect to='/' />;
  }

  const openSidebar = () => {
    setSidebarOpen(true);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className='container'>
      <Navbar sidebarOpen={sidebarOpen} openSidebar={openSidebar} />
      <ProfilePage userData={userData} />
      <Sidebar
        sidebarOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        handleLogout={handleLogout}
      />
    </div>
  );
};

export default Profile;
